
import { defineComponent } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import { PvdModal } from 'pvd3/*';

export default defineComponent({
  name: 'ScreenerModal',
  data: function () {
    return {
      clientConstants: ClientConstants
    };
  },
  methods: {
    openScreenerModal() {
      const screenerModal = this.$refs['screener-modal'] as PvdModal;
      screenerModal.pvdOpen = true;
    }
  }
});
